export const imageLoader = (cacher, assets = [], cldApi, width, height, transformation = {}) =>
  new Promise((resolve, reject) => {
    let totalLoaded = 0;
    let images = [];

    assets.forEach((asset, i) => {
      const url = cldApi.getImageUrl(asset.publicId, width, height, transformation);
      images.push('');

      cacher(asset.publicId, url, width, height, transformation).then(
        loadedAsset => {
          images[i] = loadedAsset.domNode;
          totalLoaded = totalLoaded + 1;
          if (totalLoaded === assets.length) {
            resolve(images);
          }
        },
        () => {
          if (totalLoaded === assets.length) {
            reject(url);
          }
        }
      );
    });
  });
